// extracted by mini-css-extract-plugin
module.exports = {"CheckboxInput":"CheckboxInput_CheckboxInput__1qFvH"};